export default __webpack_public_path__ + "static/media/OWN.0d0226b8.svg";